export enum QueryParamNames {
    SORT = 'sort',
    SORT_DIRECTION = 'sortDirection',
    NAME = 'name',
    CREATOR = 'creator',
    SONG = 'song',
    MIN_RATING = 'minRating',
    MAX_RATING = 'maxRating',
    MIN_ENJOYMENT = 'minEnjoyment',
    MAX_ENJOYMENT = 'maxEnjoyment',
    DIFFICULTY = 'difficulty',
    LENGTH = 'length',
    MIN_DURATION = 'minSeconds',
    MAX_DURATION = 'maxSeconds',
    MIN_OBJECT_COUNT = 'minObjects',
    MAX_OBJECT_COUNT = 'maxObjects',
    MIN_DENSITY = 'minDensity',
    MAX_DENSITY = 'maxDensity',
    MIN_ID = 'minID',
    MAX_ID = 'maxID',
    MIN_SUBMISSION_COUNT = 'minSubmissionCount',
    MAX_SUBMISSION_COUNT = 'maxSubmissionCount',
    MIN_ENJOYMENT_COUNT = 'minEnjoymentCount',
    MAX_ENJOYMENT_COUNT = 'maxEnjoymentCount',
    MIN_DEVIATION = 'minDeviation',
    MAX_DEVIATION = 'maxDeviation',
    TWO_PLAYER = 'twoPlayer',
    UPDATE = 'update',
    TOP_TAG_ID = 'topTagID',
    EXCLUDE_COMPLETED = 'excludeCompleted',
    EXCLUDE_UNRATED = 'excludeUnrated',
    EXCLUDE_UNRATED_ENJOYMENT = 'excludeUnratedEnjoyment',
    EXCLUDE_RATED = 'excludeRated',
    EXCLUDE_RATED_ENJOYMENT = 'excludeRatedEnjoyment',
    IN_PACK = 'isInPack',
}
